import { NotifyHelper } from "../../../helpers/toast";
import { objThongTinCbnvDefine } from "../../action-types/thongtin-cbnv/IThongTinCbnvActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const thongTinCbnvActions = {
    ...generateActions(objThongTinCbnvDefine, "THONG_TIN_CBNV"),
    ...generateActionForKey(objThongTinCbnvDefine, "THONG_TIN_CBNV",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objThongTinCbnvDefine, "THONG_TIN_CBNV",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objThongTinCbnvDefine, "THONG_TIN_CBNV",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objThongTinCbnvDefine, "THONG_TIN_CBNV",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objThongTinCbnvDefine, "THONG_TIN_CBNV",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
